import { useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { getActiveHash } from '../../cookieManager';
import { useAuth } from '../../hooks/useAuth';

const AuthedRoute = ({ children }) => {
  const [isReady, setIsReady] = useState(false);
  let active_hash = getActiveHash();
  const location = useLocation();
  const navigate = useNavigate();

  const { user, isLoading: isLoadingUser } = useAuth();
  //const { user: auth0User, getAccessTokenSilently, isLoading: isLoadingAuth0User } = useAuth0();

  if (user) {
    return children;
  } else {
    return <Navigate to='/signin' replace state={{ path: location.pathname }} />;
  }

  /*  useEffect(() => {
    const getAuth0Token = async () => {
      const accessToken = await getAccessTokenSilently();
      return accessToken;
    };

    if (isLoadingUser || isLoadingAuth0User) {
      return;
    }

    if (user) {
      setIsReady(true);
      return;
    }
    if (auth0User) {
      getAuth0Token()
        .then((res) => {
          localStorage.setItem('active_hash', res);
          setIsReady(true);
        })
        .catch((err) => {
          navigate('/signin', { replace: true, state: { path: location.pathname } });
        });
      return;
    }

    if (!active_hash) {
      setIsReady(true);
    }
  }, [user, auth0User, getAccessTokenSilently, isLoadingUser, isLoadingAuth0User]);

  if (!isReady) {
    return <SpinningLoader />;
  }
  if (!active_hash) {
    return <Navigate to='/signin' replace state={{ path: location.pathname }} />;
  }

  if (isReady) {
    return children;
  } */
};

export default AuthedRoute;
